import {
  GET_ORDER,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PAGE,
  SET_SEARCH,
  SHOW_MESSAGE,
  SET_ORDER_BY,
  SET_SORT_BY,
  SET_REFUND_STATUS,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getOrder = () => {
  const limit = 10;
  return (dispatch, getState) => {
    const state = getState().orders;
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/order/list", {
        searchText: state.search,
        page: state.page,
        limit,
        includeDetails: true, // Request detailed product information
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_ORDER,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const editOrderDetails = (formData) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    return jwtAxios
      .post("/order/edit-order", formData)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Order updated successfully.",
          });
          dispatch(getOrder());
          return Promise.resolve();
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
          return Promise.reject();
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
        return Promise.reject(error);
      });
  };
};

export const setRefundStatus=(type)=>{
  return (dispatch, getState) => {
    const state = getState().orders;
    dispatch({ type: FETCH_START });
    dispatch({ type: SET_REFUND_STATUS, payload: type });
    const payload={
      searchText: state.search,
      page: state.page,
      isRefundTable:true,
      limit:10,
    }
    if(type.length) payload.refundStatus=type;
    jwtAxios
      .post("/order/list",payload )
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_ORDER,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
}

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};

export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};

export const getRefundRequestOrders = () => {
  const limit = 10;
  return (dispatch, getState) => {
    const state = getState().orders;
    dispatch({ type: FETCH_START });

    const payload ={
      searchText: state.search,
      page: state.page,
      // isRefundTable: true,
      // orderby: state.orderby,
      // sortby: state.sortby,
      limit,
    }
    if(state.refundStatus) payload.refundStatus=state.refundStatus
    jwtAxios
      .post("/order/list", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_ORDER,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setOrderBy = (orderby) => {
  return (dispatch) => {
    dispatch({ type: SET_ORDER_BY, payload: orderby });
  };
};
export const setSortBy = (sortby) => {
  return (dispatch) => {
    dispatch({ type: SET_SORT_BY, payload: sortby });
  };
};

// export const callRefundAPI = (orderId,key) => {
export const callRefundAPI = (
  orderId, 
  key, 
  refundAmount = null, 
  refundType = 'PARTIAL_REFUND',
  productAmount = 0,
  taxAmount = 0,
  shippingAmount = 0,
  refundItems = null, // Array of items with refund details
) => {
  return (dispatch) => {
    const urls = {
      AUTO:'/refund/confirm',
      MANUAL:'/refund/manualRefund',
      CANCEL:'/refund/cancelRefund'
    } 
    
    dispatch({ type: FETCH_START });
    // Build the payload with all refund information
    const payload = { 
      orderId,
      refundType,
      amount: refundAmount,
      productAmount,
      taxAmount,
      shippingAmount
    };
    
    // Add refundItems to payload if provided
    if (refundItems && Array.isArray(refundItems) && refundItems.length > 0) {
      payload.refundItems = refundItems;
    }
    
    // Add refund details if not for cancel operation
    if (key !== 'CANCEL') {
      payload.refundType = refundType;
      
      // For refund operations, include all amount details
      if (refundAmount !== null) {
        // Use the correct field names for the backend API
        payload.amount = refundAmount; // TotalRefundedAmount
        payload.productAmount = parseFloat(productAmount) || 0; // RefundedProductAmount
        payload.taxAmount = parseFloat(taxAmount) || 0; // RefundedTaxAmount
        payload.shippingAmount = parseFloat(shippingAmount) || 0; // RefundedShippingAmount
        
        // Include detailed refund items if available
        if (refundItems && Array.isArray(refundItems) && refundItems.length > 0) {
          payload.items = refundItems;
        }
      }
    }
    // console.log("payload & key",payload,key);
 
    jwtAxios
      .post(urls[key], payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          
          // Create a more detailed success message if corrective invoice info is available
          let successMessage = data.data.msg || 'Refund processed successfully';
          
          // Check if we have corrective invoice information
          if (data.data.data && data.data.data.correctiveInvoiceNumber) {
            successMessage += `. Corrective invoice #${data.data.data.correctiveInvoiceNumber} generated.`;
          }
          
          dispatch({
            type: SHOW_MESSAGE,
            payload: successMessage,
          });
          
          dispatch(getRefundRequestOrders());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        let displayMessage = "Something went wrong. Please try again!"; // Default message
        const apiError = error.response?.data?.msg;

        if (apiError && typeof apiError === 'object' && apiError.response && typeof apiError.response.message === 'string') {
          displayMessage = apiError.response.message;
        } else if (apiError && typeof apiError === 'string') {
          displayMessage = apiError;
        } else if (error.message) {
          displayMessage = error.message;
        }

        dispatch({
          type: FETCH_ERROR,
          payload: displayMessage,
        });
      });
  };
};
